
import { SpecialEvent } from '../../types/specialEvent';
import { GameState } from '../GameContextTypes';

export const setCurrentSpecialEvent = (state: GameState, event: SpecialEvent | null): GameState => {
  return {
    ...state,
    currentSpecialEvent: event
  };
};
